itsoftApp.createModule("scrollEffects", ["windowScroll"], function() {
    var module = this;

    function ScrollEffect(self, classAnimate, oldClass) {
        this._self = self;
        this._classAnimate = classAnimate;
        this._oldClass = oldClass;
        this._scrollPoint;
        this._position = "bottom";
        this._get = window.innerHeight;
        if (this._self.hasAttribute("data-position")) {
            this._position = this._self.getAttribute("data-position");
        }
        this.init();
    }

    ScrollEffect.prototype.calculateValue = function (cb) {
        if (this._position === "middle") {
            this._positionValue = window.innerHeight / 2;
        } else if (this._position === "top") {
            this._positionValue = 0;
        } else {
            this._positionValue = window.innerHeight;
        }

        return this._positionValue;
    }

    ScrollEffect.prototype.init = function() {
        var self = this;

        self._check = function (scroll) {
            var scrolled = pageYOffset;
            var coeff;

            self._scrollPoint = parseInt(self._self.getBoundingClientRect().top);

            if (scrolled + self.calculateValue() >= self._scrollPoint + scrolled) {
                self.start();
            }
        }

        module.scrollEffectElements.push(self);

        self._check();

        itsoftApp.modules.windowScroll.addEvent(self._check);
    }

    ScrollEffect.prototype.start = function() {
        if (this._oldClass) {
            if (this._self.classList.contains("js-slider")) {
                this._self.classList.remove(this._oldClass);
                if (this._classAnimate) {
                    this._self.classList.add(this._classAnimate);
                }
                this._oldClass = undefined;
                var sliderSettingsKey = this._self.getAttribute("data-slider-settings"); // получаем data-атрибут
                var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига
                if (sliderSettingsKey && sliderSettingsObject) {
                    itsoftApp.modules.slidersLibrary.callback(this._self, sliderSettingsObject[sliderSettingsKey]);
                } else {
                    itsoftApp.modules.slidersLibrary.callback(this._self);
                }
            }

            if (this._self.classList.contains("js-accordion")) {
                this._self.classList.remove(this._oldClass);
                if (this._classAnimate) {
                    this._self.classList.add(this._classAnimate);
                }
                this._oldClass = undefined;
                itsoftApp.modules.accordion.callback(this._self);
            }

            if (this._self.classList.contains("js-circle-section")) {
                this._self.classList.remove(this._oldClass);
                if (this._classAnimate) {
                    this._self.classList.add(this._classAnimate);
                }
                this._oldClass = undefined;
                itsoftApp.modules.createCircle.callback();
            }

            if (this._self.classList.contains("js-tabs-section")) {
                this._self.classList.remove(this._oldClass);
                if (this._classAnimate) {
                    this._self.classList.add(this._classAnimate);
                }
                this._oldClass = undefined;
                itsoftApp.modules.toggleTabs.callback.init(this._self);
            }

            if (this._self.classList.contains("js-video-block")) {
                this._self.classList.remove(this._oldClass);
                if (this._classAnimate) {
                    this._self.classList.add(this._classAnimate);
                }
                this._oldClass = undefined;
                itsoftApp.modules.video.callback(this._self);
            }

            if (this._self.classList.contains("buying__widget")) {
                this._self.classList.remove(this._oldClass);
                if (this._classAnimate) {
                    this._self.classList.add(this._classAnimate);
                }
                this._oldClass = undefined;
                let jsOpenUteka = document.querySelector('.js-open-uteka');
                if (jsOpenUteka) {
                    jsOpenUteka.addEventListener('click', function() {
                        itsoftApp.modules.utekaInit.callback(this._self);
                        itsoftApp.modules.uteka.callback(this._self);
                        itsoftApp.modules.insertUtekaSlider.callback(this._self);
                    }, {once : true})
                }
            }
        }
    }


    module.ScrollEffect = ScrollEffect;
    module.scrollEffectElements = [];
});
